import { render, staticRenderFns } from "./CourseWitness.vue?vue&type=template&id=1b353b71&scoped=true&"
import script from "./CourseWitness.vue?vue&type=script&lang=js&"
export * from "./CourseWitness.vue?vue&type=script&lang=js&"
import style0 from "./CourseWitness.vue?vue&type=style&index=0&id=1b353b71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b353b71",
  null
  
)

export default component.exports